import { useState, type UIEvent } from 'react';

const DEFAULT_FADE_RANGE_PX = 48;

export const useScrollFadeProgress = (
  fadeRangePx: number = DEFAULT_FADE_RANGE_PX,
) => {
  const [progress, setProgress] = useState(0);

  const handleScroll = (event: UIEvent<HTMLDivElement>) => {
    const next = Math.min(event.currentTarget.scrollTop / fadeRangePx, 1);
    setProgress(next);
  };

  return { progress, handleScroll };
};
